import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Building2, Network } from 'lucide-react';

export const RealEstateAdvisory = () => {
  return (
    <div className="service-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">
          <ArrowLeft size={18} />
          Back to Home
        </Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Real Estate Advisory</span>
      </div>

      {/* Hero Section */}
      <section className="service-detail-hero">
        <div className="service-detail-icon">
          <Building2 size={48} />
        </div>
        <h1 className="service-detail-title">Real Estate Advisory</h1>
        <p className="service-detail-subtitle">
          Strategic land advisory for institutional investments, developer partnerships, and large-scale acquisitions across India
        </p>
      </section>

      {/* Overview */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <h2 className="service-section-title">What We Do</h2>
          <p className="service-section-text">
            We connect landowners, developers, and investors to maximize opportunities in real estate across India. Our advisory services span the entire spectrum of real estate transactions, from land acquisition to joint venture structuring and institutional capital deployment.
          </p>
        </div>
      </section>

      {/* Services Offered */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <h2 className="service-section-title">Our Services</h2>
          <div className="service-features-grid">
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Land Acquisition</h3>
              <p className="feature-card-text">
                Sale and purchase of land across PAN India for solar parks, industrial parks, warehouses, schools, hospitals, colleges, townships, agricultural estates and resorts
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Joint Ventures</h3>
              <p className="feature-card-text">
                Strategic collaborations and joint ventures for schools, hotels and hospitals with developer partnerships and capital structuring
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Developer Advisory</h3>
              <p className="feature-card-text">
                Strategic land acquisitions for developers with market analysis, feasibility studies, and transaction structuring
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Institutional Investments</h3>
              <p className="feature-card-text">
                Facilitating institutional investments in development projects with due diligence and investment structuring
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Residential Advisory</h3>
              <p className="feature-card-text">
                Advisory services in Delhi NCR for premium residential projects
              </p>
            </div>
            <div className="service-feature-card">
              <CheckCircle size={24} className="feature-icon" />
              <h3 className="feature-card-title">Commercial Developments</h3>
              <p className="feature-card-text">
                Advisory for commercial developments including Vatika, Worldmark, Unity and other premium projects
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Transaction Pipeline */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="service-pipeline-highlight">
            <h2 className="pipeline-title">Current Transactions in Pipeline</h2>
            <div className="pipeline-metric-large">USD 100 Mn+</div>
            <p className="pipeline-description-large">
              Ongoing advisory mandates across land acquisitions, joint developments, institutional investments and commercial real estate transactions.
            </p>
          </div>
        </div>
      </section>

      {/* Target Sectors */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <h2 className="service-section-title">Target Sectors</h2>
          <div className="sectors-list">
            <div className="sector-item">Solar Parks & Renewable Energy</div>
            <div className="sector-item">Industrial Parks & Warehousing</div>
            <div className="sector-item">Educational Institutions</div>
            <div className="sector-item">Healthcare Facilities</div>
            <Link to="/services/land-asset-transactions" className="sector-item-link">
              <div className="sector-item sector-item-clickable">
                Land & Asset Transactions
                <span className="sector-arrow">→</span>
              </div>
            </Link>
            <div className="sector-item">Agricultural Estates</div>
            <Link to="/services/hospitality-resorts" className="sector-item-link">
              <div className="sector-item sector-item-clickable">
                Hospitality & Resorts
                <span className="sector-arrow">→</span>
              </div>
            </Link>
            <Link to="/services/commercial-leasing" className="sector-item-link">
              <div className="sector-item sector-item-clickable">
                Commercial Leasing
                <span className="sector-arrow">→</span>
              </div>
            </Link>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="service-cta-box">
            <h2 className="cta-title">Explore Real Estate Opportunities</h2>
            <p className="cta-text">
              Connect with our advisory team to discuss strategic land acquisitions, joint ventures, or institutional investment opportunities.
            </p>
            <Link to="/#contact" className="btn-primary">
              Schedule Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
